import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { EnterprisesCollection } from './enterprises.types';

export function enterprisesBackend(): Backend<EnterprisesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUserId, ids, query, order) => ({
      endpoint: 'users/0.1/enterprises/',
      params: {
        enterprises: ids,
        names: getQueryParamValue(query, 'name'),
        internal_names: getQueryParamValue(query, 'internalName'),
        seo_urls: getQueryParamValue(query, 'seoUrl'),
        ignore_test: query?.searchQueryParams.ignoreTest,
        offset: query?.searchQueryParams.offset,
      },
    }),
    push: (authUid, enterprise, extra) => ({
      endpoint: 'users/0.1/enterprises/',
      payload: {
        name: enterprise.name,
        description: enterprise.description,
        landing_page_url: enterprise.landingPageUrl,
        logo_file_id: enterprise.logoFileId,
        avatar_file_id: enterprise.avatarFileId,
        has_insource_pool: extra ? !!extra.hasInsourcePool : undefined,
      },
      extractId: response => response.enterprise.id,
    }),
    set: undefined,
    update: (authUid, enterprise, originalEnterprise) => ({
      endpoint: `users/0.1/enterprises/${originalEnterprise.id}`,
      method: 'PUT',
      payload: {
        name: enterprise.name,
        description: enterprise.description,
        landing_page_url: enterprise.landingPageUrl,
        logo_file_id: enterprise.logoFileId,
        avatar_file_id: enterprise.avatarFileId,
      },
    }),
    remove: undefined,
  };
}
